export default __webpack_public_path__ + "images/9c789cc00db103855120612e56a88bd4.png";